module.exports = __webpack_public_path__ + "static/media/ICT-4.797e9859.png";